import { createAction } from 'helpers/actionHelpers/createAction'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { Communication } from 'tangle-shared'

type SetDeviceInfoPayload =
  & Partial<Communication.AppDeviceInfo>

type SetDeviceInfoResponse =
  & Partial<Communication.AppDeviceInfo>
  & {
    deviceIdSum: number | null
  }

export class SetDeviceInfoAction extends createRequestAction<'SET_DEVICE_INFO', SetDeviceInfoPayload, SetDeviceInfoResponse>('SET_DEVICE_INFO') {}

export class SetupDeviceInfoAction extends createAction<'SETUP_DEVICE_INFO', void>('SETUP_DEVICE_INFO') {}


export type DeviceAction =
  | typeof SetDeviceInfoAction.Type
  | SetupDeviceInfoAction
